import React from 'react';
import PropTypes from 'prop-types';
import Content from './components/Content';
import Header from './components/Header';
import Subheader from './components/Subheader';
import Divider from './components/Divider';
import { st, classes } from './Card.st.css';
import { CardProps } from './Card.types';

const Card = ({
  stretchVertically = false,
  showShadow = false,
  hideOverflow,
  highlight,
  className,
  children,
  controls,
  dataHook,
}: CardProps) => (
  <div
    className={st(
      classes.card,
      { stretchVertically, hideOverflow, showShadow, highlight },
      className,
    )}
    data-hook={dataHook}
  >
    {controls && <div className={classes.controls}>{controls}</div>}
    {children}
  </div>
);

Card.displayName = 'Card';

Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  controls: PropTypes.node,
  stretchVertically: PropTypes.bool,
  showShadow: PropTypes.bool,
  hideOverflow: PropTypes.bool,
  dataHook: PropTypes.string,
  highlight: PropTypes.oneOf(['focus']),
};

Card.Content = Content;
Card.Header = Header;
Card.Divider = Divider;
Card.Subheader = Subheader;

export default Card;
